import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { body4SemiBold } from "shared/styles/typography";

import { useStatusColor } from "../../hooks";
import ProgressBarTitle from "../ProgressBarTitle";
import { SingleStatusProps } from "./types";

const SingleStatus = ({ status }: SingleStatusProps) => {
    const { gray700 } = colors;

    const { getStatusColor } = useStatusColor();

    return (
        <div
            css={css({
                display: "flex",
                alignItems: "center",
                columnGap: "4px"
            })}
        >
            <span
                css={css({
                    display: "inline-block",
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    background: getStatusColor(status)
                })}
            />

            <span css={[body4SemiBold, { color: gray700 }]}>
                <ProgressBarTitle status={status} />
            </span>
        </div>
    );
};

export default SingleStatus;
